<template>
    <v-container fluid pa-0 dark flat my-5>
        <v-layout row wrap class="inner-container" justify-center mx-5>
			<v-flex xs12 justify-center class="text-xs-center">
				<h1 class="text-duo">Cotizar Mudanza en Santiago</h1>
                <v-btn
                    color="primary"
					dark
                    :to="{ name: 'mudanza' }"
                >Ir a cotizar</v-btn>
				<v-divider></v-divider>
                <br>
                <div style="text-align: center;">
                    <p>Si lo que estas buscando es realizar una <strong>mudanza dentro de Santiago</strong>, haz llegado al lugar correcto, en DUO Transportes nos encargaremos de llevar a cabo el mejor servicio.</p>
                    <p>Podrás elegir el tipo de servicio, este podrá ser un servicio Básico que consistirá solo en el transporte de parte de nuestro equipo de profesionales de un punto a otro de <strong>Santiago y otras comunas</strong> o el servicio Completo que consta no solo del transporte si no que tambien destinaremos ayudantes que se encargaran de la carga del transporte en el punto de origen con el maximo cuidado y de la descarga en el destino siempre poniendo como prioridad el mejor de los servicios.</p>
                </div>
			</v-flex>
		</v-layout>
    </v-container>
</template>
<script>
export default {
	name: 'Santiago',
    data () {
        return {

        }
    }
  }
</script>
